import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web-apps/web-apps/apps/action-portal/app/ClientProviders.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InternationalizationClientProvider"] */ "/home/runner/work/web-apps/web-apps/apps/action-portal/components/InternationalizationClientProvider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ActionPortalNavigation"] */ "/home/runner/work/web-apps/web-apps/apps/action-portal/components/navigation/ActionPortalNavigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web-apps/web-apps/apps/action-portal/components/theme/ThemeRegistry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorDialogContext"] */ "/home/runner/work/web-apps/web-apps/packages/shared/error-dialog/index.tsx");
